__webpack_require__.p = "https://shafa.ua/cloud-cgi/static/shafa/build/";